import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../contexts/AuthContext";

/**
 * Prüft, ob der aktuelle User Zugriff auf ein Feature hat.
 * Liefert:
 *   - true: aktiv
 *   - false: nicht aktiv
 *   - null: noch am Laden
 */
export function useFeatureAccess(featureKey: string): boolean | null {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user || !featureKey) {
      setEnabled(false);
      return;
    }

    let alive = true;
    const checkFeature = async () => {
      const { data, error } = await supabase
        .from("user_feature_subscriptions")
        .select("id")
        .eq("user_id", user.id)
        .eq("feature_key", featureKey)
        .eq("is_active", true)
        .maybeSingle();

      if (!alive) return;
      if (error) {
        console.warn("useFeatureAccess failed", featureKey, error);
        setEnabled(false);
        return;
      }
      setEnabled(!!data);
    };

    checkFeature();
    return () => {
      alive = false;
    };
  }, [user, featureKey]);

  return enabled;
}
